// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"5":"5270c5fd","13":"a5f05942","152":"714b0dce","329":"42b55431","435":"91e9b589","767":"5b6295ee"}[chunkId] + ".css";
};